(() => {
	const initSlider = () => {
		$(".section-recommended_products").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");

			const id = $(this).attr("id");
			const box = $(this).find(".recommended-products");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;

			if (autoplay) {
				box.find(".swiper-pagination span").addClass("autoplay-active");
				autoplayParm = {
					autoplay: {
						delay: delay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParm = {};
			}

			const swiperParms = {
				effect: box.data("effect"),
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: false,
				keyboard: true,
				loop: false,
				mousewheel: {
					forceToAxis: true,
				},
			};

			const swiperImg = new Swiper(`#${id} .swiper-image`, {
				...swiperParms,
				speed: speed,
				effect: "slide",
				navigation: {
					nextEl: `#${id} .swiper-btn--next`,
					prevEl: `#${id} .swiper-btn--prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					renderBullet: function (index, className) {
						return (
							'<span class="' + className + '">' + "0" + (index + 1) + "</span>"
						);
					},
				},

				...autoplayParm,
			});

			const swiperText = new Swiper(`#${id} .swiper-text`, {
				...swiperParms,
				speed: speed / 2,
				effect: "fade",
				fadeEffect: { crossFade: true },
				slidesPerView: 1,
				on: {
					init: function () {},
					slideChangeTransitionStart: function (swiper) {
						let bullets = document.querySelectorAll(
							`#${id} .swiper-pagination-bullet`
						);
						let activeIndex = swiper.realIndex;

						bullets.forEach((bullet, index) => {
							bullet.classList.remove("prev", "next");
							if (index === activeIndex - 1) {
								bullet.classList.add("prev");
							}
							if (index === activeIndex + 1) {
								bullet.classList.add("next");
							}
						});
					},
					slideNextTransitionStart: function () {
						let bullets = document.querySelector(
							`#${id} .swiper-pagination-bullet.next`
						);
						let x = document.querySelectorAll(
							`#${id} .swiper-pagination-bullet`
						);

						if (autoplay) {
							if (bullets) {
								bullets.classList.add("opacity-0");
								setTimeout(() => {
									bullets.classList.remove("opacity-0");
								}, speed);
							}

							if (
								x[x.length - 1].classList.contains(
									"swiper-pagination-bullet-active"
								) &&
								x.length == 3
							) {

								setTimeout(() => {
									x[1].classList.remove("prev");
									//x[x.length - 1].classList.add('prev')
								}, speed);
							}
						}
					},
					slidePrevTransitionStart: function () {
						let bullets = document.querySelector(
							`#${id} .swiper-pagination-bullet.prev`
						);
						if (!autoplay) {
							if (bullets) {
								bullets.classList.add("opacity-0");
								setTimeout(() => {
									bullets.classList.remove("opacity-0");
								}, speed);
							}
						}
					},
				},
			});

			// Remove the controller.control setup
			// swiperImg.controller.control = swiperText;
			// swiperText.controller.control = swiperImg;

			// Instead, use event listeners to coordinate the slides
			swiperImg.on("slideChange", () => {
				swiperText.slideTo(swiperImg.activeIndex, speed / 2);
			});

			swiperText.on("slideChange", () => {
				swiperImg.slideTo(swiperText.activeIndex, speed);
			});

			if (autoplay && stopAutoplay) {
				$(`#${id} .recommended-products_swiper`).on("mouseenter", () => {
					swiperImg.autoplay.stop();
					swiperText.autoplay.stop();
				});

				$(`#${id} .recommended-products_swiper`).on("mouseleave", () => {
					swiperImg.autoplay.start();
					swiperText.autoplay.start();
				});
			}
		});
	};

	initSlider()
	document.addEventListener('shopify:section:load', () => {
		initSlider()
	})
})();
